import { render, staticRenderFns } from "./textmessageinbox.vue?vue&type=template&id=7c158f44&"
import script from "./textmessageinbox.vue?vue&type=script&lang=js&"
export * from "./textmessageinbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports